/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef, useState } from 'react';
import { Menu } from '@/features/Menu';
import { ContactMenu } from '@/features/ContactMenu';
import { AppLink } from '@/shared/ui/AppLink';
import { SideMenuButton } from '@/features/SideMenu';
import { classNames } from '@/shared/lib/classNames/classNames';
import Logo from '@/shared/assets/icons/logo.svg?react';
import { SubMenu } from '@/features/SubMenu';
import { Dropdown } from '@/shared/ui/DropDown/DropDown';
import Shock from '@/shared/assets/icons/shockScnd.svg';
import eye from '@/shared/assets/icons/eye.svg';
import search from '@/shared/assets/icons/search.svg';
import shock from '@/shared/assets/icons/shock.svg';
import cls from './Header.module.scss';
import { useVisuallyImpairedStore } from '@/entities/VisuallyImpaired';

interface HeaderProps {
    className?: string;
}
const dropdownData = [
    {
        options: [
            {
                label: 'Заявить о страховом случае онлайн',
                url: 'https://sberbank-insurance.ru/online-helper/online-podacha-zayavleniya',
            },
            {
                label: 'Уточнить список документов и способы подачи',
                url: 'https://sberbank-insurance.ru/online-helper?utm_medium=our_traffic',
            },
        ],
        placeholder: 'Заявить о страховом случае',
        logo: Shock,
    },
];

export const Header = (props: HeaderProps) => {
    const { className } = props;
    const handleSelect = (value: any) => {
        console.log('Selected Value:', value);
    };

    const [openLang, setOpenLang] = useState(false);

    const { setVI } = useVisuallyImpairedStore();

    const loadScripts = async () => {
        const btn = document.getElementById('specialButton');
        btn?.click();
        setVI(true);
    };

    const ref = useRef<HTMLDivElement>(null);

    const handleClickOutside = (event: MouseEvent) => {
        if (ref.current && !ref.current.contains(event.target as Node)) {
            setOpenLang(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <header className={classNames(cls.Header, {}, [className])}>
            <div className={cls.wrapper}>
                <div className={cls.content}>
                    <div className={cls.leftContent}>
                        <div className={cls.logo}>
                            <AppLink to="https://sberbank-insurance.ru/" icon={<Logo className={cls.logoIcon} />} />
                        </div>
                        <div className={cls.block}>
                            <Menu />
                            <ContactMenu />
                        </div>
                    </div>
                    <div className={cls.rightContent}>
                        <a href="/" className={`${cls.shock} ${cls.iconBtn}`}>
                            <img src={shock} alt="shock" />
                        </a>
                        <a href="https://sberbank-insurance.ru/search" className={`${cls.search} ${cls.iconBtn}`}>
                            <img src={search} alt="search" />
                        </a>
                        <div className={cls.langWrapper}>
                            <div
                                ref={ref}
                                onClick={() => setOpenLang(true)}
                                className={classNames(cls.language, { [cls.langOpen]: openLang }, [cls.iconBtn])}
                            >
                                <p className={cls.langItem}>RU</p>
                                {openLang && (
                                    <a className={cls.langItem} href="https://sberbank-insurance.ru/about_us">
                                        CH
                                    </a>
                                )}
                            </div>
                        </div>
                        <button onClick={loadScripts} type="button" className={`${cls.eye} ${cls.iconBtn}`}>
                            <img src={eye} alt="eye" />
                        </button>
                        <SideMenuButton />
                    </div>
                </div>
                <div className={cls.subContent}>
                    <div className={cls.subBlock}>
                        <SubMenu styleType="onMenu" />
                        <Dropdown
                            options={dropdownData[0].options}
                            onSelect={handleSelect}
                            placeholder={dropdownData[0].placeholder}
                            logo={dropdownData[0].logo}
                            styleType="rightMenu"
                        />
                    </div>
                </div>
            </div>
        </header>
    );
};
